<template>
<div style="position: relative">
  <div v-if="!!winningCoupon && winningCoupon.valueId" style="position: fixed; top: 0px; left: 0px; width: 100vw;">
    <div v-for="item in 10" :key="item" class="confetti"> </div>
  </div>

  <div v-if="showLogin" style="width: 350px; margin: auto">
    <h1 style="margin-bottom: 30px">
      {{ $vuetify.lang.t('$vuetify.lottery.loginTitle') }}
    </h1>
    <login @loginComplete="completeLogin" />
  </div>
  <template v-else-if="coupons == null">
    <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
  </template>
  <h1 v-else-if="!coupons.length">
    {{ $vuetify.lang.t('$vuetify.lottery.noCoupons') }}
  </h1>
  <div v-else id="spinnerContainer">
    <h1 style="margin-bottom: 30px">
      {{ $vuetify.lang.t('$vuetify.lottery.title') }}
    </h1>

  <spinner :coupons="coupons" @spinnerFinished="winningCoupon = $event" :key="spinnerKey" @goHomeReset="handleGoHomeReset" />

    <v-alert v-if="!!winningCoupon" border="bottom" color="primary">
      <template v-if="winningCoupon.valueId">
        <h2 class="clear-text" style="margin-bottom: 20px">
          {{ $vuetify.lang.t('$vuetify.lottery.youWon') }}
        </h2>
        <h4 class="clear-text">
          {{ (winningCoupon.name || winningCoupon.rewardName) | translate }}
        </h4>
        <template v-if="mode === 'MOBILE' && spinLimitsPerGuest > 1">
          <v-btn color="info" style="margin-top: 20px; width: 100%" @click="useCoupon">
            {{ $vuetify.lang.t('$vuetify.lottery.useCoupon') }}
          </v-btn>
          <v-btn color="info" style="margin-top: 20px; width: 100%" @click="tryAgain">
            {{ $vuetify.lang.t('$vuetify.lottery.spinAgain') }}
          </v-btn>
        </template>
        <template v-else-if="mode === 'MOBILE' && spinLimitsPerGuest === 1">
          <v-btn color="info" style="margin-top: 20px; width: 100%" @click="useCoupon">
            {{ $vuetify.lang.t('$vuetify.lottery.useCoupon') }}
          </v-btn>
          <v-btn color="info" style="margin-top: 20px; width: 100%" @click="goHome">
            {{ $vuetify.lang.t('$vuetify.lottery.goShopping') }}
          </v-btn>
        </template>
        <template v-else-if="mode === 'KIOSK'">
          <v-btn color="info" style="margin-top: 20px; width: 100%" @click="goHome">
            {{ $vuetify.lang.t('$vuetify.lottery.goShopping') }}
          </v-btn>
        </template>
      </template>
      <template v-else>
        <h2 class="clear-text" style="margin-bottom: 20px">
          {{ $vuetify.lang.t('$vuetify.errorReport.main') }}
        </h2>
        <h4 class="clear-text">
          {{ $vuetify.lang.t('$vuetify.lottery.lossText') }}
        </h4>
        <template v-if="mode === 'MOBILE' && spinLimitsPerGuest > 1">
          <v-btn color="info" style="margin-top: 20px; width: 100%" @click="tryAgain">
            {{ $vuetify.lang.t('$vuetify.lottery.spinAgain') }}
          </v-btn>
          <v-btn v-if="lastSpinFailed" color="info" style="margin-top: 20px; width: 100%" @click="goHome">
            {{ $vuetify.lang.t('$vuetify.lottery.goShopping') }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn color="info" style="margin-top: 20px; width: 100%" @click="goHome">
            {{ $vuetify.lang.t('$vuetify.lottery.goShopping') }}
          </v-btn>
        </template>
      </template>
    </v-alert>
  </div>

  <!-- <v-btn v-if="getAuthToken && coupons !== null" @click="logout" color="text" id="logout">
    {{ $vuetify.lang.t('$vuetify.common.logout') }}
  </v-btn> -->
</div>
</template>

<script>
import Login from '../common/Login'
import Spinner from '../common/Spinner'

import { mapGetters, mapMutations, mapActions } from 'vuex';
import { api } from '@/plugins/api.service'

export default {
  components: { Login, Spinner },

  data: () => ({
    coupons: null,

    winningCoupon: null,
    canRespin: false,
    spinnerKey: 0,
    autoHomeTimeout: null,
    loginCompleted: false,
    showLogin: true 
  , lastSpinFailed: false
  }),

  computed: {
    ...mapGetters(['getBuild', 'getAuthToken', 'getAuthTelephone', 'getStore', 'getGuestTelephone', 'OWALink']),
    skipLoginBeforeSpinning() {
      return this.getStore?.settings?.luckyWheelSettings?.skipLoginBeforeSpinning === true;
    },
    mode() {
      return this.getStore?.settings?.luckyWheelSettings?.mode || 'MOBILE';
    },
    spinLimitsPerGuest() {
      return this.getStore?.settings?.luckyWheelSettings?.spinLimitsPerGuest || 1;
    },
    isReadyToSpin() {
      return !this.showLogin && this.coupons !== null;
    }
  },

  watch: {
    winningCoupon(newVal) {
      if (newVal) {
        this.startAutoHomeTimeout();
      }
      if (!newVal) {
        this.lastSpinFailed = false;
      }
    }
  },

  methods: {
    tryAgain() {
      this.lastSpinFailed = true;
      this.winningCoupon = null;
      this.clearAutoHomeTimeout();
      this.canRespin = false;
      this.spinnerKey++;
    },
      useCoupon() {
        if (this.OWALink) {
          window.location.href = this.OWALink;
        }
      },
    handleGoHomeReset() {
      this.clearAutoHomeTimeout();
      this.showLogin = true;
      this.winningCoupon = null;
      this.spinnerKey++;
    },
    fetchCoupons() {
      api.get(`/lucky_wheel`).then(res => {
        this.coupons = res.data.luckyWheelSettings.orderBonus.rewards

        for (let reward of this.coupons) {
          const coupon = res.data.coupons.find(coupon => coupon.code == reward.valueId)
          if (coupon)
            reward.name = coupon.nameTranslation.translations
        }

        const chanceSum = this.coupons.reduce((a, b) => a + b.chance, 0)
        if (chanceSum != 100) {
          this.coupons.push({
            name: 'Thank you',
            chance: 100 - chanceSum
          })
        }

        this.coupons = this.coupons.map(coupon => {
          return {
            ...coupon,
            chance: 100/this.coupons.length
          }
        })
      })
    },

    logout() {
      this.setAuthUser(null)
      this.setAuthToken(null)
      this.clearAutoHomeTimeout()
      window.location.reload();
    },

    goHome() {
      this.clearAutoHomeTimeout();
      this.showLogin = true;
      this.loginCompleted = false;
      this.winningCoupon = null;
      this.canRespin = false;
      this.spinnerKey++;
    },

    clearAutoHomeTimeout() {
      if (this.autoHomeTimeout) {
        clearTimeout(this.autoHomeTimeout)
        this.autoHomeTimeout = null
      }
    },

    startAutoHomeTimeout() {
      // KIOSK: always go home after 5s
      // MOBILE: win - go home after 5s if not using coupon, lose - go home after 5s
      this.autoHomeTimeout = setTimeout(() => {
        this.goHome();
      }, 5000)
    },

    resetSpinner() {
      // Close winner dialog
      this.winningCoupon = null
      this.clearAutoHomeTimeout()

      // Reset bool incase they can't respin again
      this.canRespin = false

      // Use a key to trigger an update to the spinner component
      // This sends it back to the default state and able to spin again
      this.spinnerKey++
    },
    completeLogin() {
      this.showLogin = false;
      this.loginCompleted = true;
      this.fetchCoupons();
    },

    ...mapMutations([ 'setAuthUser', 'setUserAuthToken', 'setUserAuthTelephone', 'setAuthToken' ]),
    ...mapActions([ 'fetchExternalAuth' ])
  },

  mounted() {
    this.fetchExternalAuth()

    this.fetchCoupons()
  },

  beforeDestroy() {
    this.clearAutoHomeTimeout()
  }
}
</script>

<style scoped>
  #spinnerContainer {
    position: relative;
    padding-bottom: 40px;
  }

  #spinnerContainer .v-alert {
    position: absolute;
    top: 40%;
    left: calc(50% - 175px);

    width: 350px;
  }
  a {
    text-decoration: none;
  }

  .container {
    width: 100%;
    height: 100%;
  }
  .confetti {
    width: 15px;
    height: 15px;
    background-color: #f2d74e;
    position: absolute;
    left: 50%;
    animation: confetti 5s ease-in-out -2s infinite;
    transform-origin: left top;

    z-index: 2000;
  }
  .confetti:nth-child(1) {
    background-color: #f2d74e; left: 10%; animation-delay: 0;
  }
  .confetti:nth-child(2) {
    background-color: #95c3de; left: 20%; animation-delay: -5s;
  }
  .confetti:nth-child(3) {
    background-color: #ff9a91; left: 30%; animation-delay: -3s;
  }
  .confetti:nth-child(4) {
    background-color: #f2d74e; left: 40%; animation-delay: -2.5s;
  }
  .confetti:nth-child(5) {
    background-color: #95c3de; left: 50%; animation-delay: -4s;
  }
  .confetti:nth-child(6) {
    background-color: #ff9a91; left: 60%; animation-delay: -6s;
  }
  .confetti:nth-child(7) {
    background-color: #f2d74e; left: 70%; animation-delay: -1.5s;
  }
  .confetti:nth-child(8) {
    background-color: #95c3de; left: 80%; animation-delay: -2s;
  }
  .confetti:nth-child(9) {
    background-color: #ff9a91; left: 90%; animation-delay: -3.5s;
  }
  .confetti:nth-child(10) {
    background-color: #f2d74e; left: 100%; animation-delay: -2.5s;
  }

  @keyframes confetti {
    0% { transform: rotateZ(15deg) rotateY(0deg) translate(0,0); }
    25% { transform: rotateZ(5deg) rotateY(360deg) translate(-5vw,20vh); }
    50% { transform: rotateZ(15deg) rotateY(720deg) translate(5vw,60vh); }
    75% { transform: rotateZ(5deg) rotateY(1080deg) translate(-10vw,80vh); }
    100% { transform: rotateZ(15deg) rotateY(1440deg) translate(10vw,110vh); }
  }

  .clear-text {
    color: white;
    text-shadow: -0.5px -0.5px 0 black, 0.5px -0.5px 0 black, -0.5px 0.5px 0 black, 0.5px 0.5px 0 black;
  }
</style>
